/* @flow */
import ApplicationNetworkStatesStore from './applicationNetworkStates/store'
import EndDeviceStatesStore from './endDeviceStates/store'
import GatewayStatesStore from './gatewayStates/store'
import OrganizationStatesStore from './organizationStates/store'
import SystemStatesStore from './systemStates/store'

export default {
  modules: {
    lens_an_states: ApplicationNetworkStatesStore,
    lens_ed_states: EndDeviceStatesStore,
    lens_gw_states: GatewayStatesStore,
    lens_org_states: OrganizationStatesStore,
    lens_sys_states: SystemStatesStore
  }
}



// WEBPACK FOOTER //
// ./src/modules/storeModules.js